import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { Check } from "lucide-react";
import { OFFERS } from "../../data/content";

export const Pricing = ({ onSelect }) => (
  <section
    id="ofertas"
    data-testid="pricing-section"
    className="bg-mutedbg/50 border-y border-line"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
      <div className="text-center max-w-2xl mx-auto mb-16 md:mb-20">
        <Reveal>
          <div className="eyebrow text-accent mb-5">Elige tu ritual</div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-ink leading-[0.95] tracking-tight text-4xl sm:text-5xl lg:text-6xl">
            Tres ofertas, un mismo
            <br /> <span className="italic text-brand-soft">poder botánico</span>
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 text-ink/60 text-base">
            Mientras más llevas, mejor precio por unidad. Precios en pesos
            colombianos (COP).
          </p>
        </Reveal>
      </div>

      <div className="grid lg:grid-cols-3 gap-6 lg:gap-8 items-stretch">
        {OFFERS.map((o, i) => (
          <Reveal key={o.id} delay={i * 0.1} className="h-full">
            <motion.div
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              data-testid={`offer-card-${o.id}`}
              className={`group relative h-full flex flex-col rounded-3xl p-8 md:p-10 ${
                o.highlight
                  ? "bg-brand text-white lg:-mt-6 lg:mb-0 shadow-[0_30px_70px_rgba(58,75,60,0.25)]"
                  : "bg-surface text-ink border border-line"
              }`}
            >
              {o.badge && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-accent text-white text-xs px-4 py-1.5 tracking-wide uppercase z-10">
                  {o.badge}
                </span>
              )}

              <div
                className={`rounded-2xl mb-7 h-52 md:h-60 flex items-center justify-center overflow-hidden ${
                  o.highlight
                    ? "bg-[radial-gradient(circle_at_50%_40%,#333333,#141414)]"
                    : "bg-[radial-gradient(circle_at_50%_40%,#F5F0E6,#E3DCCB)]"
                }`}
              >
                <img
                  src={o.img}
                  alt={o.name}
                  className="max-h-[84%] w-auto object-contain transition-transform duration-700 group-hover:scale-[1.06] drop-shadow-[0_18px_30px_rgba(26,37,27,0.3)]"
                />
              </div>

              <div className={`eyebrow mb-2 ${o.highlight ? "text-accent" : "text-accent"}`}>
                {o.units}
              </div>
              <h3 className="font-serif text-3xl md:text-4xl mb-6">{o.name}</h3>

              <div className="flex items-baseline gap-2 mb-1">
                <span className="font-serif text-5xl md:text-6xl leading-none">
                  ${o.price}
                </span>
                <span className={`text-sm ${o.highlight ? "text-white/60" : "text-ink/50"}`}>
                  COP
                </span>
              </div>
              <div className={`text-sm mb-8 ${o.highlight ? "text-white/60" : "text-ink/50"}`}>
                {o.per}
              </div>

              <ul className="space-y-3 mb-10">
                {o.perks.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-sm">
                    <Check
                      size={18}
                      className={`mt-0.5 shrink-0 ${o.highlight ? "text-accent" : "text-brand-soft"}`}
                    />
                    <span className={o.highlight ? "text-white/85" : "text-ink/75"}>
                      {p}
                    </span>
                  </li>
                ))}
              </ul>

              <button
                data-testid={`offer-buy-${o.id}`}
                onClick={() => onSelect(o)}
                className={`mt-auto w-full rounded-full py-3.5 text-sm transition-colors duration-300 ${
                  o.highlight
                    ? "bg-accent text-white hover:bg-white hover:text-brand"
                    : "bg-brand text-white hover:bg-accent"
                }`}
              >
                Comprar (Demo)
              </button>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
